import { render, staticRenderFns } from "./CustomersForm.vue?vue&type=template&id=5617f732"
import script from "./CustomersForm.vue?vue&type=script&lang=js"
export * from "./CustomersForm.vue?vue&type=script&lang=js"
import style0 from "./CustomersForm.vue?vue&type=style&index=0&id=5617f732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports